import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../loading/spinner";

// Helper: get appointments from localStorage
const getAppointments = () => {
  try {
    return JSON.parse(localStorage.getItem("appointments")) || [];
  } catch {
    return [];
  }
};

// Helper: save appointments to localStorage
const saveAppointments = (appointments) => {
  localStorage.setItem("appointments", JSON.stringify(appointments));
};

const EditPatient = ({
  resetval,
  patientValue,
  patientDetails,
  reset,
  resett,
  closeEdit,
}) => {
  const [loading, setLoading] = useState(false);

  const handleEditPatientData = () => {
    if (!patientDetails || !patientDetails.id) {
      toast.error("Invalid patient data.");
      return;
    }

    setLoading(true);

    // Get all appointments
    const appointments = getAppointments();

    // Find the appointment to update
    const index = appointments.findIndex(
      (apt) => apt.id === patientDetails.id
    );

    if (index === -1) {
      toast.error("Appointment not found.");
      setLoading(false);
      return;
    }

    // Update the appointment with patientValue
    // patientValue could be an object with fields to update, or a single value
    let updatedAppointment = { ...appointments[index] };

    if (patientValue && typeof patientValue === "object") {
      // If patientValue is an object, merge it (update multiple fields)
      updatedAppointment = {
        ...updatedAppointment,
        ...patientValue,
        updatedAt: new Date().toISOString(),
      };
    } else if (patientValue !== undefined && patientValue !== null) {
      // If patientValue is a primitive, update a specific field
      // We'll assume the field to update is "name" or we can pass field name
      // Since we don't know the exact field, we'll try to update "name" or use as is
      // Better: We can assume patientValue is the new value for the field that was changed
      // But to be safe, we'll only update if patientDetails has a fieldName prop
      if (patientDetails.fieldName) {
        updatedAppointment[patientDetails.fieldName] = patientValue;
      } else {
        // Fallback: update the whole patient object (if patientValue is a string, update name)
        if (typeof patientValue === "string") {
          updatedAppointment.name = patientValue;
        }
      }
    }

    // Save updated list
    appointments[index] = updatedAppointment;
    saveAppointments(appointments);

    toast.success("Patient details updated successfully!");

    setLoading(false);

    // Call all reset callbacks
    if (resetval) resetval();
    if (reset) reset();
    if (resett) resett();
    if (closeEdit) closeEdit();
  };

  return (
    <div
      id="login-popup"
      tabIndex="-1"
      className="bg-black/50 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 h-full items-center justify-center flex"
    >
      <div className="relative p-4 w-full max-w-md h-full md:h-auto">
        <div className="relative bg-white rounded-lg shadow">
          {/* Close button */}
          <button
            type="button"
            className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center popup-close"
            onClick={closeEdit}
          >
            <svg
              aria-hidden="true"
              className="w-5 h-5"
              fill="#c6c7c7"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
            <span className="sr-only">Close popup</span>
          </button>

          {/* Confirmation text */}
          <div className="p-10">
            Do you really want to change patient details?
            <div className="flex pt-6">
              <button
                type="button"
                onClick={closeEdit}
                className="flex ml-auto text-white bg-gray-500 border-0 py-2 px-6 hover:bg-gray-700 focus:outline-none rounded"
              >
                No
              </button>
              <button
                type="button"
                onClick={handleEditPatientData}
                disabled={loading}
                className="flex ml-2 text-white bg-red-500 border-0 py-2 px-6 hover:bg-red-700 focus:outline-none rounded disabled:opacity-50"
              >
                {loading ? "Updating..." : "Yes"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Display spinner when loading */}
      {loading && <Spinner />}
    </div>
  );
};

export default EditPatient;